import signalr from './src';

export default signalr;



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/node_modules/react-native-signalr/index.js